export const add = (date, amount, unit) => {
  const newDate = new Date(date)
  const originalDay = newDate.getDate()

  switch (unit) {
    case 'years':
      newDate.setFullYear(newDate.getFullYear() + amount)
      if (newDate.getDate() < originalDay) {
        // Ajustar para o último dia do mês
        newDate.setDate(0)
      }
      break

    case 'months':
      const targetMonth = newDate.getMonth() + amount
      newDate.setMonth(targetMonth)

      // Corrigir se o novo mês não tem o mesmo dia
      if (newDate.getDate() < originalDay) {
        newDate.setDate(0) // Último dia do mês anterior
      }
      break

    case 'weeks':
      newDate.setDate(newDate.getDate() + amount * 7)
      break

    case 'days':
      newDate.setDate(newDate.getDate() + amount)
      break
    case 'hours':
      newDate.setHours(newDate.getHours() + amount)
      break
    case 'minutes':
      newDate.setMinutes(newDate.getMinutes() + amount)
      break
    case 'seconds':
      newDate.setSeconds(newDate.getSeconds() + amount)
      break
  }

  return newDate
}
